import { CardLabel } from "@src/components/card_label";
import { DigixMilestone } from "@src/types/project_types";
import { Col, Row } from "antd";
import dayjs from "dayjs";
import "./digix_milestone.less";

interface DigiXMilestoneProps {
  milestone: DigixMilestone;
}

const DigiXMilestone: React.FC<DigiXMilestoneProps> = ({ milestone }) => {
  return (
    <Row
      className="digix-milestone"
      justify={"space-between"}
      gutter={[10, 10]}
      style={{ margin: "10px 0" }}
    >
      <Col span={18}>
        <CardLabel label="Mandatory Milestone" showToolTip={false}>
          {milestone.fieldName}
        </CardLabel>
      </Col>
      <Col span={6}>
        <CardLabel
          label={milestone.isComplete ? "Completed On" : "Forecast"}
          showToolTip={false}
        >
          {milestone.date ? dayjs(milestone.date).format("DD/MM/YYYY") : "N.A."}
        </CardLabel>
      </Col>
    </Row>
  );
};

export default DigiXMilestone;
